var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-provider", {
    attrs: {
      mode: "lazy",
      rules: _vm.required
        ? "required|perfis_setor_unique|perfis_externo|perfis_setor_unique_reurb"
        : "",
      name: "cadastroUsuario/perfis",
      slim: "slim"
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var errors = ref.errors
          return [
            _c("app-label", {
              attrs: { label: "Perfis:", required: _vm.required }
            }),
            _c(
              "el-select",
              {
                staticClass: "full-width input",
                class: { erro: errors.length },
                attrs: {
                  multiple: "multiple",
                  "value-key": "id",
                  filterable: "filterable",
                  placeholder: "Selecione o(s) perfil(is) do usuário",
                  "no-match-text": "Nenhum perfil encontrado"
                },
                on: { change: _vm.changePerfis },
                model: {
                  value: _vm.perfisSelecionados,
                  callback: function($$v) {
                    _vm.perfisSelecionados = $$v
                  },
                  expression: "perfisSelecionados"
                }
              },
              _vm._l(_vm.perfisAgrupado, function(setor) {
                return _c(
                  "el-option-group",
                  {
                    key: setor.nome,
                    attrs: { label: _vm.formatNomeSetor(setor.nome) }
                  },
                  _vm._l(setor.perfis, function(perfil) {
                    return _c("el-option", {
                      key: perfil.id,
                      attrs: { label: perfil.nome, value: perfil }
                    })
                  }),
                  1
                )
              }),
              1
            ),
            errors[0] && _vm.value.length === 0
              ? _c("span", { staticClass: "help erro" }, [
                  _vm._v("É necessário inserir pelo menos um perfil.")
                ])
              : errors[0]
              ? _c("span", { staticClass: "help erro" }, [
                  _vm._v(_vm._s(errors[0]))
                ])
              : _vm._e()
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c471f0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c471f0c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/seguranca/components/AppInputPerfil.vue
// module id = null
// module chunks = 